import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin');
import { OnInit, OnDestroy, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { formatWorkspaceDate } from "src/libs/portal/season/util/workspace-date";

@Component({
    selector: 'wiz-page-admin',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin/view.scss */
@charset "UTF-8";
:host {
  display: block;
  min-height: 100%;
  min-width: 0;
}

.admin-page {
  max-width: 1680px;
  margin: auto;
  padding: 22px var(--workspace-gutter, 24px) 32px;
  color: var(--ui-ink);
  font-size: 14px;
  line-height: 1.5;
}
.admin-page *, .admin-page *::before, .admin-page *::after {
  box-sizing: border-box;
}
.admin-page h1, .admin-page h2, .admin-page h3, .admin-page p {
  margin: 0;
}
.admin-page h1 {
  font-size: 26px;
  line-height: 1.35;
  font-weight: 700;
  letter-spacing: -0.025em;
}
.admin-page h2 {
  font-size: 15px;
  font-weight: 650;
}
.admin-page h3 {
  font-size: 13px;
  font-weight: 600;
}
.admin-page a {
  color: var(--ui-accent);
  text-decoration: none;
}
.admin-page button, .admin-page input, .admin-page select, .admin-page textarea {
  font: inherit;
}
.admin-page button, .admin-page a {
  touch-action: manipulation;
}
.admin-page button {
  cursor: pointer;
}
.admin-page button:disabled {
  cursor: default;
  opacity: 0.55;
}
.admin-page :is(button, a, input, select, textarea, summary):focus-visible {
  outline: 2px solid var(--ui-accent);
  outline-offset: 3px;
}
.admin-page :is(button, a, input, select, textarea, summary) {
  scroll-margin-top: calc(var(--workspace-header-height, 0px) + 12px);
}
.admin-page input, .admin-page select, .admin-page textarea {
  width: 100%;
  min-width: 0;
  border: 1px solid var(--ui-control);
  border-radius: var(--ui-control-radius, 9px);
  min-height: 36px;
  background: var(--ui-paper);
  color: var(--ui-ink);
  padding: 6px 10px;
  font-size: 13px;
}
.admin-page select {
  appearance: auto;
}
.admin-page input::placeholder, .admin-page textarea::placeholder {
  color: var(--ui-muted);
  opacity: 1;
}
.admin-page textarea {
  resize: vertical;
}
.admin-page label {
  display: block;
  color: var(--ui-text);
  font-size: 13px;
}
.admin-page label > input, .admin-page label > select, .admin-page label > textarea {
  display: block;
  margin-top: 4px;
}
.admin-page input[type=checkbox] {
  appearance: auto;
  width: 18px;
  height: 18px;
  min-height: 18px;
  flex: 0 0 18px;
  padding: 0;
  margin: 0;
  border-radius: 3px;
  accent-color: var(--ui-accent);
}
.admin-page .page-heading, .admin-page .page-title, .admin-page .page-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.admin-page .page-heading {
  justify-content: space-between;
  margin-bottom: 20px;
  min-height: 40px;
}
.admin-page .page-title {
  flex-wrap: wrap;
  gap: 4px 12px;
}
.admin-page .page-actions {
  flex: none;
  gap: 16px;
}
.admin-page .page-actions .compact-evaluate {
  display: none;
}
.admin-page .header-count, .admin-page .snapshot, .admin-page .muted {
  font-size: 12px;
  color: var(--ui-muted);
}
.admin-page .text-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 36px;
  padding: 4px 0;
  border: 0;
  background: transparent;
  color: var(--ui-accent);
  font-size: 13px;
  font-weight: 550;
  white-space: normal;
  text-align: left;
}
.admin-page .text-button:hover:not(:disabled) {
  text-decoration: underline;
  text-underline-offset: 3px;
}
.admin-page .button, .admin-page .icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 36px;
  padding: 6px 12px;
  border-radius: var(--ui-control-radius, 9px);
  border: 1px solid var(--ui-control);
  background: var(--ui-paper);
  color: var(--ui-text);
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  transition: background-color var(--ui-duration, 180ms) var(--ui-ease), border-color var(--ui-duration, 180ms) var(--ui-ease);
}
.admin-page .button.primary {
  background: var(--ui-accent);
  border-color: var(--ui-accent);
  color: var(--ui-on-navy);
}
.admin-page .button.primary:hover:not(:disabled) {
  background: var(--ui-accent-hover);
}
.admin-page .button.secondary:hover:not(:disabled), .admin-page .icon-button:hover:not(:disabled) {
  background: var(--ui-selected);
  border-color: var(--ui-accent);
}
.admin-page .icon-button {
  width: 36px;
  padding: 0;
  flex: none;
}
.admin-page .section-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.admin-page .operations {
  display: grid;
  gap: 18px;
}
.admin-page .work-register, .admin-page .deliverables, .admin-page .users-workspace {
  min-width: 0;
  background: var(--ui-paper);
  border: 1px solid var(--ui-line);
  border-radius: 14px;
}
.admin-page .work-register, .admin-page .deliverables {
  overflow: clip;
}
.admin-page .work-register {
  background: var(--ui-soft);
}
.admin-page .work-register .register-heading {
  background: var(--ui-navy);
  color: var(--ui-on-navy);
}
.admin-page .work-register .register-heading > span {
  color: color-mix(in srgb, var(--ui-on-navy) 78%, var(--ui-navy));
}
.admin-page .work-register .register-columns {
  background: transparent;
}
.admin-page .work-register .work-row {
  background: var(--ui-paper);
}
.admin-page .work-register .register-note {
  background: var(--ui-soft);
}
.admin-page .register-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
}
.admin-page .register-heading h2 {
  font-size: 16px;
  font-weight: 650;
}
.admin-page .deliverables .register-heading {
  background: var(--ui-soft);
}
.admin-page .register-heading > span {
  font-size: 12px;
  color: var(--ui-muted);
}
.admin-page .register-columns, .admin-page .work-row {
  display: grid;
  grid-template-columns: minmax(145px, 0.85fr) minmax(0, 2fr) 140px;
  gap: 16px;
  align-items: center;
  padding: 8px 16px;
}
.admin-page .register-columns, .admin-page .deliverable-columns {
  background: var(--ui-soft);
  color: var(--ui-muted);
  font-size: 12px;
  border-block: 1px solid var(--ui-line);
}
.admin-page .register-columns > span:last-child, .admin-page .deliverable-columns > span:last-child {
  text-align: right;
}
.admin-page .work-row {
  min-height: 76px;
  border-bottom: 1px solid var(--ui-line);
}
.admin-page .work-row > p {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px 18px;
  color: var(--ui-text);
  font-size: 13px;
  font-variant-numeric: tabular-nums;
}
.admin-page .work-row h3 {
  font-size: 14px;
}
.admin-page .work-row strong {
  font-size: 17px;
  font-weight: 650;
  color: var(--ui-ink);
}
.admin-page .work-row small {
  font-size: 12px;
  color: var(--ui-muted);
}
.admin-page .work-row .text-button {
  justify-self: end;
  min-height: 36px;
  padding: 6px 10px;
  border: 1px solid var(--ui-control);
  border-radius: 8px;
  background: var(--ui-paper);
}
.admin-page .work-row .text-button:hover {
  background: var(--ui-selected);
  text-decoration: none;
}
.admin-page .work-row .needs-attention, .admin-page .work-row .needs-attention strong {
  color: var(--ui-warning);
}
.admin-page .register-note {
  padding: 8px 16px;
  font-size: 12px;
  color: var(--ui-muted);
}
.admin-page .deliverable-columns, .admin-page .deliverable-row {
  display: grid;
  grid-template-columns: minmax(150px, 1.05fr) minmax(140px, 0.9fr) minmax(170px, 1fr) 130px;
  align-items: center;
  gap: 16px;
  padding: 8px 16px;
}
.admin-page .deliverable-row {
  min-height: 52px;
  border-bottom: 1px solid var(--ui-line);
  font-size: 13px;
}
.admin-page .deliverable-row > strong {
  font-weight: 600;
}
.admin-page .candidate-count {
  font-size: 12px;
  color: var(--ui-text);
  font-variant-numeric: tabular-nums;
}
.admin-page .candidate-count b {
  font-size: 15px;
  color: var(--ui-ink);
  margin-left: 4px;
}
.admin-page .latest-export {
  font-size: 12px;
  color: var(--ui-muted);
  font-variant-numeric: tabular-nums;
}
.admin-page .deliverable-row > .text-button {
  justify-self: end;
}
.admin-page .export-criteria {
  padding: 0 16px;
}
.admin-page .export-criteria > summary {
  font-size: 12px;
  font-weight: 500;
  min-height: 36px;
  padding: 8px 0;
}
.admin-page .export-criteria dl {
  margin: 0 0 12px;
  font-size: 12px;
}
.admin-page .export-criteria dl > div {
  display: grid;
  grid-template-columns: 180px 1fr;
  gap: 16px;
  padding: 5px 0;
}
.admin-page .export-criteria dt {
  font-weight: 550;
}
.admin-page .export-criteria dd {
  margin: 0;
  color: var(--ui-muted);
}
.admin-page .operations-status {
  padding: 14px 18px;
  border-top: 1px solid var(--ui-control);
  background: transparent;
}
.admin-page .jobs-summary {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}
.admin-page .jobs-summary h2 {
  font-size: 13px;
}
.admin-page .jobs-summary dl {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  gap: 6px 24px;
  margin: 0;
}
.admin-page .jobs-summary dl > div {
  display: flex;
  gap: 8px;
  align-items: baseline;
  font-size: 13px;
  color: var(--ui-text);
}
.admin-page .jobs-summary dd {
  margin: 0;
  font-weight: 650;
  font-variant-numeric: tabular-nums;
  color: var(--ui-ink);
}
.admin-page .operations-status > .muted {
  margin-top: 2px;
}
.admin-page .user-queue-tabs {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 12px 18px 0;
  background: var(--ui-soft);
  border-radius: 14px 14px 0 0;
}
.admin-page .user-queue-tabs button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 38px;
  padding: 8px 12px;
  border: 0;
  border-radius: 8px;
  color: var(--ui-text);
  font-size: 13px;
  font-weight: 600;
}
.admin-page .user-queue-tabs button.active {
  background: var(--ui-navy);
  color: var(--ui-on-navy);
}
.admin-page .user-queue-tabs span {
  font-variant-numeric: tabular-nums;
}
.admin-page .account-section-title {
  font-size: 14px;
  margin: 4px 0 12px;
}
.admin-page .account-editor .change-reason {
  max-width: 560px;
  margin-top: 16px;
}
.admin-page .user-filters {
  display: grid;
  grid-template-columns: minmax(160px, 420px) 140px 140px;
  gap: 8px;
  padding: 12px 18px 0;
  background: var(--ui-soft);
  border-radius: 0;
}
.admin-page .user-search, .admin-page .source-search {
  display: flex;
  gap: 6px;
  min-width: 0;
}
.admin-page .user-search input, .admin-page .source-search input {
  min-width: 0;
}
.admin-page .user-filters label > select {
  margin: 0;
}
.admin-page .list-summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  min-height: 38px;
  padding: 4px 18px;
  background: var(--ui-soft);
  font-size: 12px;
  color: var(--ui-muted);
}
.admin-page .list-summary strong {
  font-weight: 600;
  color: var(--ui-text);
}
.admin-page .list-summary .text-button {
  min-height: 28px;
  padding: 0;
  font-size: 12px;
}
.admin-page .users-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  font-size: 13px;
}
.admin-page .users-table th, .admin-page .users-table td {
  padding: 12px 18px;
  border-bottom: 1px solid var(--ui-line);
  text-align: left;
  vertical-align: middle;
}
.admin-page .users-table thead th {
  background: var(--ui-soft);
  font-size: 12px;
  color: var(--ui-muted);
  font-weight: 500;
  border-top: 1px solid var(--ui-line);
}
.admin-page .users-table th:first-child {
  width: 36%;
}
.admin-page .users-table th:nth-child(2), .admin-page .users-table th:nth-child(3) {
  width: 13%;
}
.admin-page .users-table th:nth-child(4) {
  width: 23%;
}
.admin-page .users-table th:last-child {
  width: 15%;
}
.admin-page .users-table tbody th {
  font-weight: 400;
  white-space: normal;
  overflow-wrap: anywhere;
  background: transparent;
}
.admin-page .users-table strong {
  display: block;
  font-size: 14px;
  font-weight: 650;
  color: var(--ui-ink);
}
.admin-page .users-table small {
  display: block;
  color: var(--ui-muted);
  font-size: 12px;
  overflow-wrap: anywhere;
  margin-top: 1px;
}
.admin-page .users-table td:last-child {
  text-align: right;
}
.admin-page .users-table tbody tr:hover {
  background: var(--ui-soft);
}
.admin-page .users-table tbody tr:last-child > :is(th, td) {
  border-bottom: 0;
}
.admin-page .status {
  display: inline-block;
  padding: 2px 7px;
  border-radius: 4px;
  background: var(--ui-soft);
  color: var(--ui-text);
  font-size: 12px;
  white-space: nowrap;
}
.admin-page .status.pending {
  background: color-mix(in srgb, var(--ui-warning) 12%, var(--ui-paper));
  color: var(--ui-warning);
}
.admin-page .status.disabled {
  color: var(--ui-muted);
}
.admin-page .list-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 14px;
  border-top: 1px solid var(--ui-line);
  font-size: 12px;
  color: var(--ui-muted);
}
.admin-page .list-footer nav {
  display: flex;
  gap: 8px;
}
.admin-page .empty, .admin-page .loading-note {
  padding: 16px;
  color: var(--ui-muted);
  font-size: 13px;
}
.admin-page .feedback {
  padding: 8px 0;
  font-size: 13px;
  overflow-wrap: anywhere;
}
.admin-page .feedback.error {
  color: var(--ui-danger);
}
.admin-page .feedback.success {
  color: var(--ui-success);
}
.admin-page .feedback > .text-button {
  margin-left: 10px;
}
.admin-page .users-workspace.detail-open {
  padding: 18px 22px;
}
.admin-page .back-users {
  margin-bottom: 8px;
}
.admin-page .user-detail {
  max-width: 960px;
}
.admin-page .user-detail > .section-heading {
  margin-bottom: 12px;
}
.admin-page .user-detail > .section-heading .muted {
  margin-top: 2px;
  overflow-wrap: anywhere;
}
.admin-page .user-detail h2 {
  font-size: 17px;
}
.admin-page .user-permissions-grid {
  display: block;
}
.admin-page .account-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin: 0 0 6px;
  max-width: 560px;
}
.admin-page .account-editor > .muted {
  margin-top: 4px;
}
.admin-page .account-editor > .button {
  margin-top: 10px;
}
.admin-page .change-note {
  color: var(--ui-warning);
  font-size: 13px;
  max-width: 75ch;
  margin: 8px 0;
}
.admin-page .change-reason {
  margin: 0 0 20px;
  max-width: 720px;
  padding: 14px 16px;
  background: var(--ui-soft);
  border-radius: 10px;
}
.admin-page .change-reason > .muted {
  margin-left: 6px;
}
.admin-page .change-reason small {
  display: block;
  font-size: 12px;
  color: var(--ui-muted);
  margin-top: 4px;
}
.admin-page .permission-advanced, .admin-page .permission-history {
  border-top: 1px solid var(--ui-line);
  margin-top: 14px;
}
.admin-page details > summary {
  cursor: pointer;
  min-height: 40px;
  padding: 10px 0;
  color: var(--ui-text);
  font-size: 13px;
  font-weight: 600;
}
.admin-page .permission-history > summary > span {
  margin-left: 8px;
  font-size: 12px;
  color: var(--ui-muted);
  font-weight: 400;
}
.admin-page .qualification-actions {
  display: flex;
  align-items: end;
  flex-wrap: wrap;
  gap: 10px;
  margin: 8px 0 14px;
}
.admin-page .qualification-actions > label {
  max-width: 140px;
}
.admin-page .assignments {
  padding-top: 14px;
  border-top: 1px solid var(--ui-line);
}
.admin-page .assignments > p {
  margin: 4px 0 8px;
}
.admin-page .assignment-list, .admin-page .source-options, .admin-page .permission-history ol {
  padding: 0;
  margin: 0;
  list-style: none;
}
.admin-page .assignment-list li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid var(--ui-line);
  padding: 10px 0;
}
.admin-page .assignment-list li > div {
  min-width: 0;
}
.admin-page .assignment-list strong, .admin-page .assignment-list span, .admin-page .assignment-list small {
  display: block;
  overflow-wrap: anywhere;
}
.admin-page .assignment-list strong {
  font-size: 13px;
  font-weight: 600;
}
.admin-page .assignment-list span, .admin-page .assignment-list small {
  font-size: 12px;
  color: var(--ui-muted);
}
.admin-page .assignment-list .text-button {
  flex: none;
}
.admin-page .assign-new {
  margin-top: 8px;
}
.admin-page .source-search {
  max-width: 560px;
  margin: 8px 0;
}
.admin-page .source-options button {
  width: 100%;
  text-align: left;
  background: none;
  border: 0;
  border-bottom: 1px solid var(--ui-line);
  padding: 8px 10px;
  min-height: 40px;
  font-size: 13px;
  color: var(--ui-text);
  overflow-wrap: anywhere;
}
.admin-page .source-options button.selected {
  background: var(--ui-selected);
  color: var(--ui-accent);
}
.admin-page .source-pages {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  align-items: center;
  font-size: 12px;
  color: var(--ui-muted);
}
.admin-page .selected-source {
  font-size: 13px;
  color: var(--ui-accent);
  margin: 8px 0;
  overflow-wrap: anywhere;
}
.admin-page .assignment-fields {
  display: flex;
  align-items: end;
  flex-wrap: wrap;
  gap: 12px;
  margin: 12px 0;
}
.admin-page .assignment-fields > label {
  max-width: 180px;
}
.admin-page .assignment-fields > label:not(.checkbox-label) {
  min-width: 120px;
}
.admin-page .assignment-fields .checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  max-width: none;
  cursor: pointer;
}
.admin-page .permission-history li {
  padding: 10px 0;
  border-top: 1px solid var(--ui-line);
}
.admin-page .permission-history li > div {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
}
.admin-page .permission-history li > div > span {
  font-size: 12px;
  color: var(--ui-muted);
}
.admin-page .permission-history li > p {
  margin-top: 4px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font-size: 13px;
}
.admin-page .qa-review-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 16px;
  margin-bottom: 16px;
  background: var(--ui-soft);
  border: 1px solid var(--ui-line);
  border-radius: 10px;
}
.admin-page .qa-review-summary > div {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px 14px;
}
.admin-page .qa-review-summary h2 {
  font-size: 13px;
  white-space: nowrap;
}
.admin-page .qa-review-summary p {
  font-size: 12px;
  color: var(--ui-muted);
  font-variant-numeric: tabular-nums;
}
.admin-page .qa-review-summary strong {
  color: var(--ui-ink);
  font-weight: 600;
}
.admin-page .qa-review-summary > a {
  flex: none;
  min-height: 32px;
  border: 0;
  background: transparent;
  padding: 3px 0;
  color: var(--ui-accent);
}
.admin-page .access-state {
  padding: 16px 0;
}
.admin-page .access-state a {
  margin-top: 12px;
}
.admin-page .sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@media (max-width: 1100px) and (min-width: 961px) {
  .admin-page .deliverable-columns, .admin-page .deliverable-row {
    grid-template-columns: minmax(150px, 1fr) minmax(120px, 0.8fr) minmax(120px, 0.8fr) 110px;
    gap: 12px;
  }
}
@media (max-width: 960px) {
  .admin-page {
    padding: 16px 18px 24px;
  }
  .admin-page .deliverable-columns, .admin-page .deliverable-row {
    grid-template-columns: minmax(150px, 1fr) minmax(120px, 0.8fr) minmax(120px, 0.8fr) 110px;
    gap: 12px;
  }
}
@media (max-width: 700px) {
  .admin-page .register-heading {
    align-items: baseline;
    flex-wrap: wrap;
    gap: 3px 12px;
  }
  .admin-page .page-actions .snapshot {
    display: none;
  }
  .admin-page .deliverable-columns {
    display: none;
  }
  .admin-page .deliverable-row {
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 4px 12px;
  }
  .admin-page .deliverable-row > strong {
    grid-column: 1;
    grid-row: 1;
  }
  .admin-page .candidate-count {
    grid-column: 1;
    grid-row: 2;
  }
  .admin-page .latest-export {
    grid-column: 1;
    grid-row: 3;
  }
  .admin-page .latest-export::before {
    content: "최근 내보내기 · ";
  }
  .admin-page .deliverable-row > .text-button {
    grid-column: 2;
    grid-row: 1/4;
    align-self: center;
  }
  .admin-page .export-criteria dl > div {
    grid-template-columns: minmax(0, 1fr);
    gap: 2px;
  }
}
@media (max-width: 600px) {
  .admin-page {
    padding: 14px 12px 24px;
  }
  .admin-page h1 {
    font-size: 21px;
  }
  .admin-page .page-heading {
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
  }
  .admin-page .page-actions {
    gap: 0;
  }
  .admin-page .page-actions .compact-evaluate {
    display: inline-flex;
    white-space: nowrap;
  }
  .admin-page .header-count {
    font-size: 12px;
  }
  .admin-page :is(input:not([type=checkbox]), select, textarea) {
    font-size: 16px;
    min-height: 44px;
  }
  .admin-page :is(.button, .icon-button, .text-button, details > summary, .source-options button) {
    min-height: 44px;
  }
  .admin-page .icon-button {
    min-width: 44px;
  }
  .admin-page .register-heading {
    padding: 10px 12px;
  }
  .admin-page .register-columns {
    display: none;
  }
  .admin-page .work-row {
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 2px 10px;
    padding: 10px 12px;
  }
  .admin-page .work-row h3 {
    grid-column: 1;
    grid-row: 1;
  }
  .admin-page .work-row > p {
    grid-column: 1;
    grid-row: 2;
    display: flex;
    gap: 2px 8px;
  }
  .admin-page .work-row small {
    display: block;
    width: 100%;
  }
  .admin-page .work-row .text-button {
    grid-column: 2;
    grid-row: 1/3;
  }
  .admin-page .register-note {
    padding: 8px 12px;
  }
  .admin-page .deliverable-row {
    padding: 8px 12px;
  }
  .admin-page .export-criteria {
    padding: 0 12px;
  }
  .admin-page .operations-status {
    padding: 0 4px;
  }
  .admin-page .jobs-summary {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 0 8px;
  }
  .admin-page .jobs-summary dl {
    grid-column: 1/-1;
    grid-row: 2;
    gap: 4px 16px;
  }
  .admin-page .jobs-summary > .text-button {
    grid-column: 2;
    grid-row: 1;
  }
  .admin-page .operations-status > .muted {
    margin-top: 6px;
  }
  .admin-page .user-filters {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    padding: 10px 12px 0;
  }
  .admin-page .user-search {
    grid-column: 1/-1;
  }
  .admin-page .list-summary {
    padding-inline: 12px;
  }
  .admin-page .users-table, .admin-page .users-table tbody {
    display: block;
  }
  .admin-page .users-table thead {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
  }
  .admin-page .users-table tbody tr {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 4px 12px;
    border-top: 1px solid var(--ui-line);
    padding: 10px 12px;
  }
  .admin-page .users-table tbody th {
    width: auto;
    grid-column: 1/-1;
    border: 0;
    padding: 0;
  }
  .admin-page .users-table td {
    border: 0;
    padding: 0;
    text-align: left;
  }
  .admin-page .users-table td:nth-child(4) {
    align-self: center;
    font-size: 12px;
    color: var(--ui-muted);
  }
  .admin-page .users-table td:last-child {
    text-align: right;
    align-self: center;
  }
  .admin-page .users-workspace.detail-open {
    padding: 10px 12px;
  }
  .admin-page .account-fields {
    gap: 10px;
  }
  .admin-page .permission-history li > div {
    flex-direction: column;
    gap: 3px;
  }
  .admin-page .qa-review-summary {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 0 8px;
    padding: 4px 10px;
    margin-bottom: 10px;
  }
  .admin-page .qa-review-summary > div {
    display: contents;
  }
  .admin-page .qa-review-summary h2 {
    grid-column: 1;
    grid-row: 1;
    align-self: center;
  }
  .admin-page .qa-review-summary p {
    grid-column: 1/-1;
    grid-row: 2;
    margin: 0 0 6px;
  }
  .admin-page .qa-review-summary > a {
    grid-column: 2;
    grid-row: 1;
  }
  .admin-page .assignment-fields > label {
    max-width: 100%;
  }
  .admin-page .list-footer {
    gap: 8px;
    padding: 8px 12px;
  }
}
@media (max-width: 960px), (pointer: coarse) {
  .admin-page :is(.button, .icon-button, .text-button, details > summary, .source-options button, input:not([type=checkbox]), select, textarea) {
    min-height: 44px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .admin-page :is(.button, .icon-button) {
    transition: none;
  }
}`],
})
export class PageAdminComponent implements OnInit, OnDestroy {
    workspacePage=true; user:any=null; csrf=''; ready=false; busy=false; forbidden=false; sessionExpired=false;
    error=''; notice=''; tab='overview'; overview:any=null; overviewLoading=false; overviewError='';
    users:any={items:[],total:0,page:1,pages:1,summary:{}}; usersLoading=false;
    userQuery=''; userRole=''; userStatus=''; appliedUserQuery=''; appliedUserRole=''; appliedUserStatus='';
    selectedUser:any=null; selectedUserId=''; needsUserReload=false; userLoading=false; accountRole=''; accountStatus=''; changeReason='';
    qualificationDays=30; sourceRows:any={items:[],total:0,page:1,pages:1}; sourcesLoading=false; sourceQuery=''; appliedSourceQuery=''; selectedSource:any=null;
    assignmentPurpose='REVIEW'; assignmentDays=30; allowDownload=false; initialDpoView='participants';
    roles=[{id:'admin',label:'시스템 관리자'},{id:'researcher',label:'연구 담당자'},{id:'reviewer',label:'검수·평가자'}];
    statuses=[{id:'pending',label:'승인 대기'},{id:'active',label:'활성'},{id:'disabled',label:'비활성'}];
    private dead=false; private loggedOut=false; private subscription:any; private baseline='';
    private controllers=new Set<AbortController>(); private serial={overview:0,users:0,detail:0,sources:0};
    constructor(@Inject(Service) public service:Service,@Inject(ActivatedRoute) private route:ActivatedRoute,@Inject(Router) private router:Router) {
        const initialTab=this.route.snapshot?.queryParamMap?.get('tab')||'overview';
        if(['overview','users','reviews'].includes(initialTab))this.tab=initialTab;
        const session=this.route.snapshot?.data?.['workspace']?.session;
        if(session?.code===200){this.user=session.data?.user;this.csrf=session.data?.csrf||'';}
    }
    get canManage(){return this.user?.role==='admin'&&this.user?.status==='active'&&!this.forbidden&&!this.sessionExpired;}
    get dirty(){return !!this.selectedUser&&this.editingSnapshot()!==this.baseline;}
    get accountChanged(){return !!this.selectedUser&&(this.accountRole!==this.selectedUser.user.role||this.accountStatus!==this.selectedUser.user.status);}
    get reasonValid(){return this.changeReason.trim().length>=2&&this.changeReason.trim().length<=500;}
    get selfSelected(){return this.selectedUserId===this.user?.id;}
    editingSnapshot(){return JSON.stringify([this.accountRole,this.accountStatus,this.changeReason,this.qualificationDays,this.selectedSource?.id||'',this.assignmentPurpose,this.assignmentDays,this.allowDownload]);}
    date(value:string){return formatWorkspaceDate(value);}
    roleLabel(value:string){return this.roles.find(x=>x.id===value)?.label||value;}
    statusLabel(value:string){return this.statuses.find(x=>x.id===value)?.label||value;}
    actionLabel(value:string){return ({account_create:'계정 생성',account:'계정 변경',qualify:'검수 자격 부여',unqualify:'검수 자격 해제',assign:'문헌 접근 배정',revoke:'문헌 접근 해제'} as any)[value]||value;}
    async render(){if(!this.dead)await this.service.render();}
    async focus(id:string){await this.render();document.getElementById(id)?.focus({preventScroll:true});}
    async ngOnInit(){await this.service.init();await this.initialize();if(!this.dead)this.subscription=this.route.queryParamMap.subscribe(p=>{if(this.ready&&this.canManage)void this.applyRoute(p);});}
    ngOnDestroy(){this.dead=true;this.subscription?.unsubscribe();this.controllers.forEach(c=>c.abort());}
    @HostListener('window:beforeunload',['$event'])
    beforeUnload(e:BeforeUnloadEvent){if(!this.loggedOut&&this.dirty){e.preventDefault();e.returnValue='';}}
    leave(){return this.loggedOut||(!this.busy&&(!this.dirty||window.confirm('저장하지 않은 권한 변경이 있습니다. 변경사항을 버리고 이동하시겠습니까?')));}
    canDeactivate(){return this.leave();}
    afterLogout(){this.loggedOut=true;}
    async call(action:string,values:any={},app='page.admin',method='dispatch'){
        const controller=new AbortController();this.controllers.add(controller);const timer=setTimeout(()=>controller.abort(),30000);
        try{
            const body=new URLSearchParams();for(const [k,v] of Object.entries({action,csrf:this.csrf,...values}))body.append(k,String(v));
            const response=await fetch('/wiz/api/'+app+'/'+method,{method:'POST',body,credentials:'same-origin',signal:controller.signal});
            const r=await response.json();if(this.dead)throw new Error('화면을 닫았습니다.');
            if(r.code!==200){
                if(r.code===401){this.sessionExpired=true;throw new Error('로그인이 만료되었습니다. 다시 로그인해 주세요.');}
                if(r.code===403){this.forbidden=true;throw new Error('관리자 권한이 필요합니다. 계정 권한을 확인해 주세요.');}
                throw new Error(r.data?.message||'요청을 처리하지 못했습니다. 입력 내용을 확인해 주세요.');
            }
            return r.data;
        }catch(e:any){
            if(e?.name==='AbortError')throw new Error(action==='change_user'?'저장 응답이 지연됩니다. 다시 저장하기 전에 사용자 정보와 변경 이력을 확인해 주세요.':'조회가 지연되고 있습니다. 잠시 후 다시 시도해 주세요.');
            if(e instanceof TypeError||e instanceof SyntaxError)throw new Error('서버에 연결하지 못했습니다. 잠시 후 다시 시도해 주세요.');
            throw e;
        }finally{clearTimeout(timer);this.controllers.delete(controller);}
    }
    async initialize(){
        if(this.busy||this.dead)return;this.busy=true;this.error='';await this.render();
        try{
            const d=await this.call('bootstrap');this.user=d.user;this.csrf=d.csrf;this.ready=true;
        }catch(e:any){if(!this.dead)this.error=e.message;}
        finally{this.busy=false;await this.render();}
        if(this.canManage)await this.applyRoute(this.route.snapshot.queryParamMap,true);
    }
    async setUrl(){await this.router.navigate([], {relativeTo:this.route,queryParams:{tab:this.tab,user:this.selectedUserId||null,view:this.tab==='reviews'?this.initialDpoView:null},replaceUrl:false});}
    async applyRoute(params:any,initial=false){
        const tab=['overview','users','reviews'].includes(params.get('tab'))?params.get('tab'):'overview';
        const id=tab==='users'?(params.get('user')||''):'';
        const view=params.get('view')==='results'?'results':'participants';
        if(!initial&&tab===this.tab&&id===this.selectedUserId&&view===this.initialDpoView)return;
        if(!initial&&!this.leave()){await this.router.navigate([], {relativeTo:this.route,queryParams:{tab:this.tab,user:this.selectedUserId||null,view:this.initialDpoView},replaceUrl:true});return;}
        this.tab=tab;this.selectedUser=null;this.selectedUserId=id;this.initialDpoView=view;this.error='';this.notice='';
        if(tab==='users'){if(id)await this.fetchUser(id);else await this.loadUsers(1,false);}
        else await this.loadOverview();
    }
    async changeTab(value:string,view='participants'){
        if(!['overview','users','reviews'].includes(value)||this.dead||!this.canManage||!this.leave())return;
        this.tab=value;this.selectedUser=null;this.selectedUserId='';this.initialDpoView=view;this.error='';this.notice='';
        await this.setUrl();await this.render();
        if(value==='users')await this.loadUsers(1,false);else await this.loadOverview();
    }
    async dpoViewChanged(view:string){
        if(this.dead||this.tab!=='reviews'||!this.canManage||!['participants','results'].includes(view))return;
        this.initialDpoView=view;await this.setUrl();
    }
    async loadOverview(){
        if(this.dead||!this.canManage)return;const token=++this.serial.overview;this.overviewLoading=true;this.overviewError='';await this.render();
        try{const d=await this.call('overview');if(!this.dead&&token===this.serial.overview)this.overview=d;}
        catch(e:any){if(!this.dead&&token===this.serial.overview)this.overviewError=e.message;}
        finally{if(token===this.serial.overview)this.overviewLoading=false;await this.render();}
    }
    async loadUsers(page=1,applyFilters=true){
        if(this.dead||!this.canManage||this.usersLoading)return;
        const q=applyFilters?this.userQuery:this.appliedUserQuery,role=applyFilters?this.userRole:this.appliedUserRole,status=applyFilters?this.userStatus:this.appliedUserStatus;
        const token=++this.serial.users;this.usersLoading=true;this.error='';await this.render();
        try{
            const d=await this.call('users',{q,role,status,page});
            if(this.dead||token!==this.serial.users||this.tab!=='users'||this.selectedUserId)return;
            this.users=d;this.appliedUserQuery=q;this.appliedUserRole=role;this.appliedUserStatus=status;
            this.userQuery=q;this.userRole=role;this.userStatus=status;
        }catch(e:any){if(!this.dead&&this.tab==='users'&&!this.selectedUserId)this.error=e.message;}
        finally{if(token===this.serial.users)this.usersLoading=false;await this.render();}
    }
    async selectUser(row:any){
        if(!row?.id||this.dead||!this.canManage||!this.leave())return;
        this.selectedUserId=row.id;this.selectedUser=null;this.error='';this.notice='';await this.setUrl();await this.fetchUser(row.id);
    }
    async fetchUser(id:string){
        const token=++this.serial.detail;this.userLoading=true;await this.render();
        try{
            const d=await this.call('user_detail',{user:id});
            if(this.dead||token!==this.serial.detail||this.selectedUserId!==id||this.tab!=='users')return;
            this.needsUserReload=false;this.selectedUser=d;this.accountRole=d.user.role;this.accountStatus=d.user.status;this.changeReason='';
            this.qualificationDays=30;this.sourceRows={items:[],total:0,page:1,pages:1};this.sourceQuery='';this.appliedSourceQuery='';this.selectedSource=null;
            this.assignmentPurpose=d.user.role==='external'?'EVALUATE':'REVIEW';this.assignmentDays=30;this.allowDownload=false;this.baseline=this.editingSnapshot();
        }catch(e:any){if(!this.dead&&this.selectedUserId===id)this.error=e.message;}
        finally{if(token===this.serial.detail)this.userLoading=false;await this.render();}
    }
    async closeUser(){
        if(!this.leave())return;this.selectedUser=null;this.selectedUserId='';this.error='';this.notice='';await this.setUrl();await this.loadUsers(this.users.page,false);
    }
    async saveUser(operation='account',assignmentId:any=null){
        if(this.busy||this.dead||!this.canManage||!this.selectedUser||this.needsUserReload||!this.reasonValid)return;
        const target=this.selectedUserId;const data:any={reason:this.changeReason.trim()};
        if(operation==='account'){if(!this.accountChanged)return;data.role=this.accountRole;data.status=this.accountStatus;}
        else if(operation==='qualify')data.days=this.qualificationDays;
        else if(operation==='assign'){if(!this.selectedSource)return;Object.assign(data,{source:this.selectedSource.id,purpose:this.assignmentPurpose,days:this.assignmentDays,allow_download:this.allowDownload});}
        else if(operation==='revoke'){if(!assignmentId)return;data.assignment=assignmentId;}
        else if(operation!=='unqualify')return;
        this.busy=true;this.error='';this.notice='';await this.render();
        try{
            await this.call('change_user',{user:target,operation,data:JSON.stringify(data)});
            if(this.dead)return;
            this.changeReason='';this.baseline=this.editingSnapshot();
            if(target===this.user.id){this.notice='권한을 저장했습니다. 변경 적용을 위해 다시 로그인해 주세요.';this.sessionExpired=true;return;}
            this.notice='권한을 저장했습니다. 변경 사유와 이력을 기록했습니다.';this.needsUserReload=true;await this.fetchUser(target);this.overview=null;
        }catch(e:any){if(!this.dead)this.error=e.message;}
        finally{this.busy=false;await this.render();}
    }
    async loadSources(page=1,applyFilters=true){
        if(this.dead||this.sourcesLoading||!this.canManage||!this.selectedUser)return;
        const id=this.selectedUserId,token=++this.serial.sources,q=applyFilters?this.sourceQuery:this.appliedSourceQuery;
        if(!q.trim()){this.sourceRows={items:[],total:0,page:1,pages:1};await this.render();return;}
        this.sourcesLoading=true;this.error='';await this.render();
        try{const d=await this.call('',{q,page},'page.dashboard','sources');if(!this.dead&&token===this.serial.sources&&id===this.selectedUserId){this.sourceRows=d;this.appliedSourceQuery=q;}}
        catch(e:any){if(!this.dead&&id===this.selectedUserId)this.error=e.message;}
        finally{if(token===this.serial.sources)this.sourcesLoading=false;await this.render();}
    }
    assignmentActive(row:any){return !row.revoked_at&&new Date(row.expires_at).getTime()>Date.now();}
    chooseSource(row:any){this.selectedSource=row;void this.render();}
    async clearUserFilters(){this.userQuery='';this.userRole='';this.userStatus='';await this.loadUsers();}
    async pendingUsers(){this.userQuery='';this.appliedUserQuery='';this.userRole='';this.appliedUserRole='';this.userStatus='pending';this.appliedUserStatus='pending';await this.changeTab('users');}
}

export default PageAdminComponent;